import { render } from "./Hover.vue?vue&type=template&id=3ca23971"
import script from "./Hover.vue?vue&type=script&lang=js"
export * from "./Hover.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__